import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { Route } from '@/modules/core/app/constants/api.constants';
import { GenericModel } from '@/modules/core/app/models/GenericModel';

export class WorkflowGuidanceStepListResource extends BaseResource {
  getGuidanceStepList(
    selectedJurisdictions: Array<number> = [],
    selectedEstateTypes: Array<string> = []
  ): Promise<Array<GenericModel>> {
    return this.getData(Route.WORKFLOWS_AVAILABLE_GUIDANCE_STEPS, GenericModel, {
      selectedJurisdictions: selectedJurisdictions,
      selectedEstateTypes: selectedEstateTypes
    });
  }
}

export default new WorkflowGuidanceStepListResource();
